module.exports = __webpack_public_path__ + "img/geo-konzept_QUERFORMAT_Farbe.ddfd6770.jpg";